import { Observable } from "rxjs";
import { map, mergeMap, reduce, switchMap, windowCount } from "rxjs/operators";

const masonryPagination =
    (page$: Observable<number>) =>
    (rows$: Observable<number>): Observable<number> => {
        return rows$.pipe(
            switchMap((rows) =>
                page$.pipe(
                    // change stream from page to [page, page+1]
                    map((page) =>
                        new Array(rows)
                            .fill(page)
                            .map((v: number, idx) => v + idx)
                    ),
                    mergeMap((v) => v),
                    // convert page to perPage
                    map((currentPage) => {
                        currentPage++;
                        if (currentPage % 3 === 0) return 4;
                        return 7;
                    }),
                    windowCount(rows),
                    switchMap((win) =>
                        win.pipe(reduce((acc, value) => acc + value, 0))
                    )
                )
            )
        );
    };

export default masonryPagination;
